/**
 * Obtiene la extensión de un archivo a partir de su nombre
 *
 * @param {string} filename Nombre del archivo
 * @returns {string} Extensión del archivo
 */
export const getFileExtension = (filename) => {
  return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
};

/**
 * Obtiene el formato de un archivo a partir de su nombre
 *
 * @param {string} filename Nombre del archivo
 * @returns {string} Formato del archivo
 */
export const getFileFormat = (filename) => {
  const extension = getFileExtension(filename);

  const formats = {
    pdf: "mdi mdi-file",
    zip: "mdi mdi-zip-box",
    doc: "mdi mdi-file-word",
    xls: "mdi mdi-file-excel",
    ppt: "mdi mdi-file-powerpoint",
    txt: "mdi mdi-file-document",
    mp3: "mdi mdi-file-music",
    mp4: "mdi mdi-file-video",
  };

  return formats[extension] || "mdi mdi-file";
};
